import { IApiClient } from "../api-client";
import { EnvType } from "../services";
import { GenericResponseStd } from "../Types/generic-response-std";
import { GetMarkersResponse } from "../Types/get-markers-response";
import { ThumbnailSize } from "./thumbnail-api-service";

interface IThumbnailApiClient {
  GetThumbRefByObjectId(objectId: number, authKey: string, size?: ThumbnailSize): string;
  GetShareThumbRefCompressedByObjectId(size: ThumbnailSize, shareKey: string);
  GetSceneThumbsByObjectId(objectId: number): Promise<GetMarkersResponse>;
  GetRollThumbsVttTrackByObjectId(objectId: number, authKey: string): string;
  GetRollThumbsSpliceImageByObjectId(objectId: number, authKey: string, frameIn: number): string;
  GetMergeThumbsSpliceImageByObjectId(objectId: number, segments: number, authKey: string): string;
  GenerateMarkerThumbnailsByObjectId(objectId: number): Promise<GenericResponseStd>;
  CleanCacheThumbRefByObjectId(objectId: number): Promise<GenericResponseStd>;
}

export default class ThumbnailApiClient implements IThumbnailApiClient {
  readonly servicePort = 9517;
  readonly serviceBaseUrl = "thumbnail-service/api";

  thumbnailApiClient: IApiClient;

  constructor(thumbnailApiClient: IApiClient, envType: EnvType) {
    this.thumbnailApiClient = thumbnailApiClient;
    if (envType === "local") this.thumbnailApiClient.client.defaults.baseURL += `${this.servicePort}/`;
  }

  async CreateThumbReference(objectId: number, frame: number): Promise<GenericResponseStd> {
    return await this.thumbnailApiClient.put(`${this.serviceBaseUrl}/thumbs/reference/${objectId}/${frame}`);
  }
  GetThumbRefByObjectId(objectId: number, authKey: string, size?: ThumbnailSize): string {
    return !size
      ? this.thumbnailApiClient.client.defaults.baseURL +
          `${this.serviceBaseUrl}/thumbs/reference/${authKey}/${objectId}`
      : this.thumbnailApiClient.client.defaults.baseURL +
          `${this.serviceBaseUrl}/thumbs/reference/${size}/${authKey}/${objectId}`;
  }
  GetShareThumbRefCompressedByObjectId(size: ThumbnailSize, shareKey: string): string {
    return (
      this.thumbnailApiClient.client.defaults.baseURL +
      `${this.serviceBaseUrl}/thumbs/reference/share/${ThumbnailSize[size]}/${shareKey}`
    );
  }
  async GetSceneThumbsByObjectId(objectId: number): Promise<GetMarkersResponse> {
    return await this.thumbnailApiClient.get(`${this.serviceBaseUrl}/thumbs/scenes/${objectId}`);
  }
  GetRollThumbsVttTrackByObjectId(objectId: number, authKey: string): string {
    return (
      this.thumbnailApiClient.client.defaults.baseURL +
      `${this.serviceBaseUrl}/thumbs/stripes/${authKey}/${objectId}/vtt-track`
    );
  }
  GetRollThumbsSpliceImageByObjectId(objectId: number, authKey: string, frameIn: number): string {
    return (
      this.thumbnailApiClient.client.defaults.baseURL +
      `${this.serviceBaseUrl}/thumbs/stripes/${authKey}/${objectId}/splice/${frameIn}`
    );
  }
  GetMergeThumbsSpliceImageByObjectId(objectId: number, segments: number, authKey: string = ""): string {
    return (
      this.thumbnailApiClient.client.defaults.baseURL +
      `${this.serviceBaseUrl}/thumbs/stripes/${authKey}/${objectId}/merge/${segments}`
    );
  }
  async GenerateMarkerThumbnailsByObjectId(objectId: number): Promise<GenericResponseStd> {
    return await this.thumbnailApiClient.post(`${this.serviceBaseUrl}/thumbs/markers/${objectId}`);
  }
  async CleanCacheThumbRefByObjectId(objectId: number): Promise<GenericResponseStd> {
    return await this.thumbnailApiClient.delete(`${this.serviceBaseUrl}/thumbs/reference/${objectId}`);
  }

  //------Utils------
  GetApiUrl(): string {
    return this.thumbnailApiClient.client.defaults.baseURL + this.serviceBaseUrl;
  }
}
